import { Link, useLocation } from "react-router-dom"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb"
import { findNavItemByPath } from "../nav-config"

/**
 * Breadcrumb w topbarze. Na stronach detalu (np. /contracts/123) renderuje
 * klikalny link do listy + bieżącą stronę jako tekst placeholder ("Szczegóły").
 * Detail page sam pokazuje tytuł obiektu pod tym headerem.
 */
export function TopbarBreadcrumb() {
  const { pathname } = useLocation()
  const item = findNavItemByPath(pathname)
  const label = item?.label ?? "Strona"
  const navPath = item?.path

  // Detail page: ścieżka to /<list-path>/<id>. Zostawiamy parent jako klikalny link
  // (powrót do listy) i nie powtarzamy tytułu obiektu - zrobi to DetailHeader.
  const isOnDetailPage = navPath !== undefined && pathname.length > navPath.length && pathname.startsWith(navPath + "/")

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          {isOnDetailPage && navPath ? (
            <BreadcrumbLink asChild className="text-sm font-medium">
              <Link to={navPath}>{label}</Link>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbPage className="text-sm font-medium">{label}</BreadcrumbPage>
          )}
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
